module.exports = __webpack_public_path__ + "img/webinars-coin.52b266f.webp";